class ConfigurationManager {
    static set environment(environment) {
        this._environment = environment;
    }

    static getProperty(name) {
        return this._environment['REACT_APP_' + name];
    }
}

export default ConfigurationManager;


// WEBPACK FOOTER //
// ./src/_configuration/ConfigurationManager.js